const PayRollConciliationActionOperation = {
    Download: 1,
    Upload: 2
};

export default PayRollConciliationActionOperation;